import {
  AuditorsIntroSection,
  AuditorsMetricsSection,
  AuditorsMonitoringSection,
  AuditorsPublishSection,
  AuditorsWidgetSection,
} from '@/components/auditors';
import Head from 'next/head';

const title = 'Empowering Web3 Security Smart Contracts Auditors | Trustblock';
const description =
  'Start publishing your security smart contract audits on Trustblock and boost your profile with our metrics & API.';

function Auditors() {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <link rel="canonical" href="https://trustblock.run/auditors" />
      </Head>
      <AuditorsIntroSection />
      <AuditorsMetricsSection />
      <AuditorsWidgetSection />
      <AuditorsMonitoringSection />
      <AuditorsPublishSection />
    </>
  );
}

export default Auditors;
